import React, { useState, useEffect } from "react";

import { useTranslation } from "react-i18next";
import { cloneDeep } from "lodash";

import ActionButtonLayout from "../layout/ActionButtonLayout";
import AutoFormDialog from "../dialogTypes/AutoFormDialog";

function MomSysNoOrderPurchaseInputDoInputButton(props) {
    const { id, schema, grid, refresh, onSuccess, onFailure, customizeErrorMsgCallback, ...others } = props;

    const { t } = useTranslation();

    const [open, setOpen] = useState(false);
    const [formData, setFormData] = useState();

    const [modifiedSchema, setModifiedSchema] = useState();

    useEffect(() => {
        let modifiedSchema = cloneDeep(schema);

        modifiedSchema.columns.push(
            {
            name: "inDate",
            type: "date",
            nullable: "NO",
            default: null,
            formGroup: 1,
            formOrder: 42.5,
            formItemType: "date",
        }
        )
        if (modifiedSchema) {
            for (const column of modifiedSchema.columns) {
                switch (column.name) {
                    case "wareHouseCode":
                        column.hideInForm = false;
                        column.required = true;

                        break;

                    case "inDate":

                        column.hideInForm = false;

                        break;

                    case "inPrice":

                        column.hideInForm = false;

                        break;
                    case "inAmount":

                        column.hideInForm = false;

                        break;
                    default:
                        column.disabled = true;
                        column.required = false;
                        break;
                }
            }

            setModifiedSchema(modifiedSchema);
        }
    }, [schema]);

    const onOpen = () => {
        if (grid) {
            setFormData({ ...grid.selectedItems[0], extLotNo: "extLot" });
        }

        setOpen(true);
    };

    const onClose = () => {
        setOpen(false);
    };

    const onInputSuccess = (msg) => {
        if (onSuccess) {
            onSuccess(msg);
        }

        if (refresh) {
            refresh.refresh();
        }
    };

    return (
        <React.Fragment>
            <ActionButtonLayout id={id} onClick={onOpen} {...others}>
                {t("buttonName.input")}
            </ActionButtonLayout>
            <AutoFormDialog
                id={id + "-input-dialog"}
                mode="edit"
                formId={id + "-input-form"}
                title={schema ? t(`dialog.title.${schema.name}.input`) : ""}
                schema={modifiedSchema}
                modifyUrlCallback={(url) => `/api/MomSysNoOrderPurchaseInput/doInput`}
                initialData={formData}
                open={open}
                onClose={onClose}
                onSuccess={onInputSuccess}
                customizeErrorMsgCallback={customizeErrorMsgCallback}
                modifyFormDataCallback={(formData, name) => {
                    if (name === "qtyInput" || name === "inPrice") {
                        formData.inAmount = formData.qtyInput * formData.inPrice;
                    }
                }}
            />
        </React.Fragment>
    );
}

export default MomSysNoOrderPurchaseInputDoInputButton;
